<div
  class="hotel-cell-container"
  [class]="themeService.getTheme()"
  [style]="cardsLength ? 'height: calc(100vh - 200px)' : ''"
  [style.height]="mobStyle"
  (click)="openObjectMobile()">
  <div class="hotel-picture-container">
    <img
      [src]="card.img"
      [style.filter]="'grayscale(' + (card.style || 0) + '%) brightness(0.95)'"
      [style.cursor]="classicCursor ? 'auto' : cursor"
      (click)="openObject()"
    >
  </div>
  <div class="hotel-buttons-container" [class.services]="card.anotherHotelButton !== undefined">
    <h2 class="text-uppercase">
      <app-texts
        [texts]="[
                {text: card.text}
              ]"
      />
    </h2>
    <div class="services-text" *ngIf="card.anotherButtonText !== undefined">
      <app-texts [texts]="card.anotherButtonText"/>
    </div>
    <div class="arrow-button" (click)="openObject()" *ngIf="card.anotherButton === undefined" style="cursor: pointer">
      <app-icon class="p-3" [icon]="Icons.arrowRight"/>
    </div>
    <div
      class="button-text"
      style="cursor: pointer"
      [class.services]="true"
      (click)="openObject()"
      *ngIf="card.anotherButton !== undefined"
    >
      {{ text(['Детали', 'Details']) }}
    </div>
  </div>
  <div class="hotel-border-line hotel-border-line-left" *ngIf="!isMobile"></div>
  <div class="hotel-border-line hotel-border-line-right" *ngIf="!isMobile"></div>
</div>
